import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationService, CoursesService, PortalConfigurationService, PortalPreferencesInterface } from '@draeger-academy/common';
import { HubspotTrackingService } from '@draeger-academy/presentation';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'da-partner-app',
    templateUrl: './portal-app.component.html',
    styleUrls: ['./portal-app.component.scss'],
    standalone: false
})
export class PortalAppComponent implements OnInit {
    public errorMessage: string;
    private _portalId: string;
    private _$portalId: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    private _$portalPreferences: BehaviorSubject<PortalPreferencesInterface> = new BehaviorSubject<any>(null);
    private _$loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    private _$intro: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _$portalVersion: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _portalConfigurationService: PortalConfigurationService,
        private _configurationService: ConfigurationService,
        private _hubspotTrackingService: HubspotTrackingService
    ) {}

    public get portalId$(): Observable<any> {
        return this._$portalId.asObservable();
    }

    ngOnInit(): void {
        if (this._configurationService.isPartnerPage()) {
            if (!this._activatedRoute.snapshot.params.portalId) {
                this.errorMessage = 'No portal-configuration found (no Partner-ID).';
                this._$loading.next(false);
            } else {
                this._portalId = this._activatedRoute.snapshot.params.portalId;
                this._configurationService.setPortal(this._portalId);
                this._configurationService.$globalConfiguration.subscribe((config) => {
                    if (config) {
                        const _version =
                            this._configurationService.globalConfiguration$
                                .filter((setting) => setting.key === 'partnerV2availableFor')[0]
                                .value.indexOf(this._portalId) >= 0
                                ? 'v2'
                                : 'v1';
                        this._configurationService.setPortalVersion(_version);
                        this._$portalVersion.next(_version);
                        this._checkForPortalConfig();
                    }
                });
            }
        }
    }

    private _checkForPortalConfig() {
        this._portalConfigurationService.getPortalConfiguration().then((configuration) => {
            this._portalConfigurationService
                .checkForMatchingPortalConfig(this._portalId, configuration)
                .then((matchingPortal) => {
                    this._loadPortalPreferences();

                    this._$portalId.next(matchingPortal);
                    this._hubspotTrackingService.loadTrackingScript('');
                })
                .catch((err) => {
                    this.errorMessage = err;
                });
        });
    }

    private _loadPortalPreferences() {
        this._portalConfigurationService.loadPortalPreferences(this._portalId).then((preferences) => {
            this._$portalPreferences.next(preferences);
            this._activatedRoute.queryParams.subscribe((params) => {
                this._portalConfigurationService.checkForDefaultLanguageFromParamOrPreferences(params, this._portalId, preferences);
            });
            this._loadTranslationFileAndSetFooter();
            this._$loading.next(false);
            const portalId = preferences.name.split('_').join('-').toLocaleLowerCase();
            const defaultCountry = preferences.defaultCountry.toLocaleLowerCase();
            const preselectLanguage = this._portalConfigurationService.getPortalLanguage(this._$portalPreferences.getValue());
            const defaultLanguage = preselectLanguage || preferences.defaultLanguage.toLocaleLowerCase();
            let countryCode = defaultLanguage + '_' + defaultCountry;
            if (countryCode === 'fr_fr') {
                countryCode = 'fr_fra';
            } else if (countryCode === 'en_au') {
                countryCode = 'en_aus';
            }
            localStorage.setItem('portalCountryCode', JSON.stringify({ portalId: portalId, countryCode: countryCode }));
            this._configurationService.getCountriesAndSalutationsByLanguage(defaultLanguage);
        });
    }

    private _loadTranslationFileAndSetFooter() {
        const _lang = this._portalConfigurationService.getPortalLanguage(this._$portalPreferences.getValue());
        this._configurationService.setTranslationsAndSettings(this._portalId, _lang.toLowerCase()).then((settings) => {});
    }
}
